import TotalOfFacingsChart from "./TotalOfFacingsChart";
export default TotalOfFacingsChart;
